export function findMainNotification(mededelingen) {
  if (!mededelingen || !Array.isArray(mededelingen)) {
    return null;
  }
  return mededelingen.find((med) => med.mainNotification === true)?.mededeling || null;
}

export function computeNotice({ generalSettings, numGuests, maxGuests }) {
  const showNotice = (
    (generalSettings?.showNoticeForMaxGuests === 'Ja' && numGuests > maxGuests) ||
    (generalSettings?.showNoticeForMaxGuests !== 'Ja' && numGuests > maxGuests)
  );

  const type = generalSettings?.showNoticeForMaxGuests === 'Ja' ? 'call' : 'limit';
  return { showNotice, type };
}


